import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { $tk } from 'utils/appTranslationKey';
import { PromotionSummaryFC, PromotionSummaryFCProps } from './PromotionSummaryFC';

const useStrings = (): PromotionSummaryFCProps['strings'] => {
  const intl = useIntl();

  return useMemo(
    () => ({
      exampleBasePrice: intl.formatMessage({
        id: $tk.components.PromotionSummary.exampleBasePrice,
      }),
      exampleDescription: intl.formatMessage({
        id: $tk.components.PromotionSummary.exampleDescription,
      }),
      exampleDiscountedPrice: intl.formatMessage({
        id: $tk.components.PromotionSummary.exampleDiscountedPrice,
      }),
      exampleTitle: intl.formatMessage({ id: $tk.components.PromotionSummary.exampleTitle }),
      exampleTooltip: intl.formatMessage({ id: $tk.components.PromotionSummary.exampleTooltip }),
      durationTitle: intl.formatMessage({ id: $tk.components.PromotionSummary.durationTitle }),
      exampleType: intl.formatMessage({ id: $tk.components.PromotionSummary.exampleType }),
      promotionTitle: intl.formatMessage({ id: $tk.components.PromotionSummary.promotionTitle }),
      appliesToItemsTitle: intl.formatMessage({
        id: $tk.components.PromotionSummary.appliesToItemsTitle,
      }),
      viewAll: intl.formatMessage({ id: $tk.components.PromotionSummary.viewAll }),
    }),
    [intl],
  );
};

type PromotionSummaryProps = Omit<PromotionSummaryFCProps, 'strings'>;

export function PromotionSummary(props: PromotionSummaryProps) {
  const strings = useStrings();
  return <PromotionSummaryFC {...props} strings={strings} />;
}
